<template>
  <div class="blog-post blog">
    <header>
      <topbar />
      <navbar v-show="isMobile !== true" />
      <mobile-nav v-show="isMobile" />
      <section-header text="depNews" />
    </header>
    <main>
      <b-container class="mt-5" fluid>
        <b-row>
          <b-col sm="12" md="9" class="p-0">
            <b-row
              class="px-md-5 align-items-stretch"
              v-if="posts.length !== 0"
            >
              <b-col
                sm="12"
                md="3"
                class="mb-5"
                v-for="(post, index) in posts"
                :key="post.id"
              >
                <div
                  class="blog-card"
                  data-aos="fade"
                  :data-aos-delay="`${index + 5}00`"
                >
                  <div class="image-placeholder">
                    <img :src="getImage(post.image)" alt="" />
                  </div>
                  <div class="content">
                    <h3>
                      <router-link
                        :to="{ name: 'blog-post', params: { id: post.id } }"
                        >{{ shortenTitle(post.title) }}
                      </router-link>
                    </h3>
                    <p>
                      {{ shortenText(post.sub_description) }}
                    </p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" md="3" class="p-0 pl-md-5">
            <blog-sidebar :posts="posts" :popularPosts="popularPosts" />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="9" class="pt-5">
            <b-container>
              <b-row>
                <b-col class="d-flex justify-content-center mb-5">
                  <b-pagination
                    size="lg"
                    v-model="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    aria-controls="my-table"
                    class="mx-auto"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
          <b-col sm="12" md="3"></b-col>
        </b-row>
      </b-container>
    </main>
    <footer>
      <footer-component />
    </footer>
  </div>
</template>

<script>
import { filesUrl } from "@/main";
import MobileNav from "@/components/layout/MobileNav.component.vue";
import Topbar from "@/components/layout/Topbar.component.vue";
import Navbar from "@/components/layout/Navbar.component.vue";
import FooterComponent from "@/components/layout/FooterComponent.component.vue";
import SectionHeader from "@/components/layout/SectionHeader.component.vue";
import BlogSidebar from "@/components/blog/BlogSidebar.component.vue";
export default {
  components: {
    Topbar,
    Navbar,
    SectionHeader,
    BlogSidebar,
    FooterComponent,
    MobileNav,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      posts: [],
      popularPosts: [],
      isMobile: false,
      lang: null,
      totalCount: "",
    };
  },
  watch: {
    currentPage: {
      handler: function () {
        this.getAllPosts();
      },
    },
  },
  computed: {
    rows() {
      return this.posts.length;
    },
  },
  async mounted() {
    if (window.innerWidth > 991) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
    this.getAllPosts();
    this.getPopularPosts();
  },
  methods: {
    getAllPosts() {
      let skip = this.currentPage - 1;
      this.axios
        .get(
          `news/clint?skip=${skip}&take=${this.perPage}&department_id=${this.$route.params.id}`
        )
        .then((res) => {
          this.posts = res.data.items;
          this.totalCount = res.data.totalCount;
          this.getDep();
        });
    },
    getDep() {
      this.axios
        .get(`since/deparment/clint/${this.$route.params.id}`)
        .then((res) => {
          this.changeMeta(res.data);
        });
    },
    getPopularPosts() {
      this.axios.get("news/list/viewSort?skip=0&take=3").then((res) => {
        this.popularPosts = res.data.items;
      });
    },
    getImage(path) {
      return `${filesUrl}/${path}`;
    },
    shortenTitle(text) {
      if (text !== null) {
        if (text.length > 50) {
          let maxLength = 50;
          let trimmedString = text.substr(0, maxLength);
          return trimmedString + " ...";
        } else {
          return text;
        }
      } else {
        return "";
      }
    },
    shortenText(text) {
      if (text !== null) {
        if (text.length > 100) {
          let maxLength = 100;
          let trimmedString = text.substr(0, maxLength);
          return trimmedString + " ...";
        } else {
          return text;
        }
      } else {
        return "";
      }
    },
    changeMeta(item){
      document.querySelector('meta[name="description"]').setAttribute("content", `${item.about.vision}`);
      document.querySelector('meta[property="og:description"]').setAttribute("content", `${item.about.vision}`);
      document.querySelector('meta[property="og:image"]').setAttribute("content", `${filesUrl}${item.logo}`);
      document.getElementById("icon").setAttribute("href",`${filesUrl}${item.logo}`); 
      if(localStorage.getItem("lang")=="ar"){
      document.title = `جامعة النسور  - اخبار ${item.name} `;
      document.querySelector('meta[name="title"]').setAttribute("content",`  - اخبار ${item.name}`);
      }else{
      document.title = ` Al-Nisour University   - ${item.name} News`;
      document.querySelector('meta[property="og:title"]').setAttribute("content",`${item.name} News`);
      }
    }
  },
};
</script>
